import { render, staticRenderFns } from "./ro-itemlist.vue?vue&type=template&id=c2b5163a&class=tile&"
import script from "./ro-itemlist.vue?vue&type=script&lang=js&"
export * from "./ro-itemlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports